<template>
  <v-card :loading="!showIframePdf" tile elevation="0">
    <v-card-text>
      <iframe v-if="showIframePdf"
        class="iframe-custom"
        :src=this.pdfPage
        frameborder="0"
        scrolling="no"
        allowfullscreen>
      </iframe>
    </v-card-text>
  </v-card>

</template>

<script>
import axios from 'axios'
import { HeaderGral } from '@/store/modules/config'
export default {
  props: ['itemAction', 'setterModel', 'onSuccess'],
  data: () => ({
    pdfPage: null,
    showIframePdf: false
  }),
  components: {},
  created () {
    if (this.itemAction.url) {
      this.getDinamicData(this.ruta)
    }
  },
  methods: {
    getDinamicData (url) {
      const header = HeaderGral()
      axios.post(this.itemAction.url, this.itemAction.params, header).then((response) => {
        var binary = atob(response.data.pdf.replace(/\s/g, ''))
        var len = binary.length
        var buffer = new ArrayBuffer(len)
        var view = new Uint8Array(buffer)
        for (var i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i)
        }
        const blob = new Blob([view], { type: 'application/pdf' })
        this.pdfPage = URL.createObjectURL(blob)
        this.showIframePdf = true
      }).catch((error) => {
        if (error == null) console.log('Error')
      }).finally(() => {
      })
    }
  }
}
</script>
<style scoped>
.iframe-custom {
  width: 100%;
  height: 70vh;
}
</style>
